import {useFieldContext} from '../../utils/formContext';

import {SingleFileInput} from './SingleFileInput';

import type {SingleFileInputValue} from '../../functions/formatThumbnailBody';

type Props = Omit<
  React.ComponentProps<typeof SingleFileInput>,
  'name' | 'value' | 'onChange' | 'error'
>;
export function FormSingleFileInput(props: Props): React.JSX.Element {
  const field = useFieldContext<SingleFileInputValue>();

  return (
    <SingleFileInput
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={(value) => {
        field.handleChange(value);
        field.handleBlur();
      }}
      // onBlur={field.handleBlur}
      // onDropAccepted={(value) => {
      //   field.handleChange(value);
      //   field.handleBlur();
      // }}
      // onDropRejected={(err) => {
      //   field.handleChange(field.state.value);
      //   field.handleBlur();
      //   console.error('File input error:', err);
      //   field.setErrorMap({onChange: err});
      // }}
      // onClearValue={() => {
      //   field.handleChange({
      //     file: null,
      //     existing: false,
      //     initial: field.state.value.initial,
      //   });
      //   field.handleBlur();
      // }}
      error={field.state.meta.errors.map((e) => e.message).join(', ')}
    />
  );
}
